import { render, staticRenderFns } from "./EditCoursePage.vue?vue&type=template&id=59bec17b"
import script from "./EditCoursePage.vue?vue&type=script&lang=ts"
export * from "./EditCoursePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports